import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import React, { FC } from 'react'
import styled from 'styled-components'

const BatchActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
`

const BatchDeleteButton = styled.button`
  padding: 0.375rem;
  border: 1px solid rgba(220, 38, 38, 0.6);
  background-color: rgba(220, 38, 38, 0.1);
  border-radius: 4px;
  color: rgba(248, 113, 113, 0.9);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &:hover {
    background-color: rgba(220, 38, 38, 0.2);
    border-color: rgba(220, 38, 38, 0.8);
    color: rgba(252, 165, 165, 1);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

const ClearSelectionButton = styled.button`
  padding: 0.375rem 0.75rem;
  border: 1px solid #666666;
  background-color: #000000;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.75rem;

  &:hover {
    background-color: #444444;
    border-color: #888888;
  }
`

interface BatchAnnotationActionsProps {
  selectedAnnotationIds: Set<string>
  onClearSelection: () => void
  onBatchDelete: () => void
}

export const BatchAnnotationActions: FC<BatchAnnotationActionsProps> = ({
  selectedAnnotationIds,
  onClearSelection,
  onBatchDelete,
}) => {
  if (selectedAnnotationIds.size === 0) return null

  return (
    <BatchActionsContainer>
      <ClearSelectionButton onClick={onClearSelection}>
        Clear Selection
      </ClearSelectionButton>
      <TooltipWrapper
        label={`Delete ${selectedAnnotationIds.size} selected annotation${selectedAnnotationIds.size > 1 ? 's' : ''}`}
        side='bottom'>
        <BatchDeleteButton onClick={onBatchDelete}>
          <TrashIcon />
        </BatchDeleteButton>
      </TooltipWrapper>
    </BatchActionsContainer>
  )
}
